/* eslint-disable @typescript-eslint/naming-convention */
export enum TMPermissions {
  isCashier = 23,
  pinCode = 24,
  bettingReport = 52,
  moneyFlowReport = 55,
  bettingV2ReportView = 72,
  pLReport = 75,
  shopReportsOBO = 115,
  betAndValueTicketOBO = 116,
  terminalServiceModeNXCSSettings = 117,
  hQTransactionsOBO = 118,
  balanceOfAccountsOBO = 119,
  serviceTabOBO = 120,
  costsAndIncomesOBO = 123,
  valueTicketOBO = 138,
  canViewDailyCashReport = 108,
  canViewDailyWithdrawalDepositReport = 109,
  canViewMonthlyOverviewReport = 110,
  canViewMonthlyReport = 111

}

export enum AffiliateRole {
  cashier = 1,
  agent = 2,
  superAgent = 3,
  masterAgent = 4,
  operatorTrader = 5,
  agentManager = 6
}

export enum Gender {
  male = 1,
  female = 2
}


export enum TimesEnum {
  today = 1,
  yesterday = 2,
  manual = 3,
  lastWeek = 4,
  currentWeek = 5,
  currentMonth = 6,
  lastMonth = 7,
}

export enum TransactionType {
  all  = null,
  credit = 1, // credit
  debit = 2  // debit
  // increase = 1, // credit
  // decrease = 2  // debit
}

export enum TransactionDescription {
  reserve = 1,
  reserveCanceled = 2,
  transferAmount = 3,
  commissionCalculation = 4,
  bonus = 5
}

export enum CommissionReportsType {
  agent = 1,
  sports = 2
}

export enum CommissionReportType {
  single = 1,
  multipleBets = 2
}

export enum TicketTypeTM {
  preMatch = 1,
  live = 2,
  mix = 3
}

export enum GroupByOdds {
  date = 1,
  event = 2
}

export enum PageLayout {
  landscape = 1,
  portrait = 2
}

export enum FontSize {
  small = 1,
  normal = 2,
  large = 3
}

export enum PrintLogo {
  noLogo = 1,
  everyPage = 2,
  firstPage = 3
}


export enum SessionHistoryType {
  login = 1,
  logOut = 2,
  systemLogOut = 3
}


export enum DayOfWeek {
  sunday = 0,
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6
}

export enum MessageStatus{
  unseen = 1,
  seen = 2,
  returnedToUnseen = 3,
  deletedByReceiver = 4
}

export enum PowerBonusSettingItemUpdateType {
  none = 0,
  create = 1,
  update = 2,
  delete = 3

}

export enum CrossbookingType {
  forbidden = 1,
  onLocation = 2,
  offLocation = 3,
}

